const AFINN = {"good":3,"great":3,"love":3,"amazing":4,"awesome":4,"excellent":4,"wonderful":4,"fantastic":4,"best":3,"beautiful":3,"brilliant":3,"perfect":3,"happy":3,"exciting":3,"incredible":3,"outstanding":4,"superb":4,"impressive":3,"delightful":3,"remarkable":3,"success":2,"successful":2,"win":2,"winning":2,"won":2,"celebrate":2,"celebrated":2,"triumph":3,"popular":2,"favorite":2,"talent":2,"talented":2,"star":1,"hit":1,"top":1,"hot":1,"rise":1,"rising":1,"comeback":2,"inspire":2,"inspired":2,"inspiring":2,"praised":2,"praise":2,"record":1,"breaking":1,"award":2,"awards":2,"stunning":3,"gorgeous":3,"iconic":2,"legend":2,"legendary":2,"bad":-3,"terrible":-4,"awful":-4,"horrible":-4,"worst":-3,"hate":-3,"hated":-3,"hater":-3,"haters":-3,"ugly":-3,"disgusting":-4,"pathetic":-3,"stupid":-3,"fail":-2,"failed":-2,"failure":-2,"scandal":-3,"controversy":-2,"controversial":-2,"criticized":-2,"criticism":-2,"attack":-2,"attacked":-2,"angry":-2,"furious":-3,"outrage":-3,"outraged":-3,"slammed":-2,"blasted":-2,"accused":-2,"allegation":-2,"allegations":-2,"lawsuit":-2,"sue":-2,"sued":-2,"toxic":-3,"nasty":-3,"embarrassing":-3,"shame":-2,"shameful":-3,"disaster":-3,"flop":-2,"flopped":-2,"decline":-1,"dropped":-1,"crash":-2,"feud":-2,"divorce":-1,"breakup":-1,"fired":-2,"cancelled":-2,"canceled":-2,"backlash":-2,"deny":-1,"denied":-1,"reject":-2,"rejected":-2,"arrested":-3,"charged":-2};

export function scoreSentiment(text) {
  const words = (text || '').toLowerCase().replace(/[^a-z\s]/g, '').split(/\s+/).filter(Boolean);
  if (words.length === 0) return { label: 'neutral', score: 0 };
  let sum = 0;
  for (const w of words) {
    if (AFINN[w]) sum += AFINN[w];
  }
  const comparative = sum / words.length;
  let label = 'neutral';
  if (comparative > 0.05) label = 'positive';
  if (comparative < -0.05) label = 'negative';
  return { label, score: parseFloat(comparative.toFixed(3)) };
}

export function computeBuzz(results) {
  let totalRedditBuzz = 0;
  let gnewsCount = 0;
  for (const r of results) {
    if (r.platform === 'reddit') {
      totalRedditBuzz += Math.log10((r.upvotes || 0) + 1) * 10;
    }
    if (r.platform === 'gnews') gnewsCount++;
  }
  const newsBuzz = Math.log10(gnewsCount + 1) * 25;
  return Math.min(100, Math.round(newsBuzz + totalRedditBuzz));
}

export function computeSummary(results) {
  const counts = { positive: 0, neutral: 0, negative: 0 };
  for (const r of results) {
    counts[r.sentiment.label]++;
  }
  const overall_sentiment = results.length > 0
    ? Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0]
    : 'neutral';
  const buzz_score = computeBuzz(results);
  return { overall_sentiment, buzz_score, counts };
}
